import axios from 'axios'


export default axios.create({
    baseURL: 'https://apis.shawees.com/api/v1/drivers-panel/drivers/',
    headers: {

        'Content-type': 'application/json'
    }
}) 